"use strict";
/**
 * To use different hosts for ROW and China regions
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHost = void 0;
const getHost = (CNRegion) => CNRegion ? 'completeanatomy.cn' : '3d4medical.com';
exports.getHost = getHost;
